import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

const qs = (filters = {}) => {
  const p = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") p.append(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
};

// ---- Eligibility (COMPLETED + date passed) ----
export const getEligibleSchedulesForMarks = async (filters = {}) => {
  const res = await axiosInstance.get(`/marks/eligible${qs(filters)}`);
  return res.data;
};

export const getTeachersForSchedule = async (scheduleId, filters = {}) => {
  const res = await axiosInstance.get(
    `/marks/teachers-for-schedule/${scheduleId}${qs(filters)}`
  );
  return res.data;
};

// ---- Assign ----
export const createMarksAssignment = async (data) => {
  const res = await axiosInstance.post("/marks/assign", data);
  return res.data;
};

export const getAllMarksAssignments = async (filters = {}) => {
  const res = await axiosInstance.get(`/marks/assignments/all${qs(filters)}`);
  return res.data;
};

export const updateMarksAssignmentStatus = async (id, data) => {
  const res = await axiosInstance.put(`/marks/assignments/status/${id}`, data);
  return res.data;
};

// ---- Entry ----
export const getStudentsForMarksEntry = async (assignmentId) => {
  const res = await axiosInstance.get(`/marks/entry/${assignmentId}`);
  return res.data;
};

export const saveMarksEntry = async (data) => {
  const res = await axiosInstance.post("/marks/entry/save", data);
  return res.data;
};

export const submitMarksEntry = async (assignmentId) => {
  const res = await axiosInstance.post(`/marks/entry/submit/${assignmentId}`);
  return res.data;
};

// ---- View ----
export const getMarksForSection = async (filters = {}) => {
  const res = await axiosInstance.get(`/marks/section${qs(filters)}`);
  return res.data;
};
